var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"section-subtitle"},[_vm._v(_vm._s(_vm.cardData.cta_text))]),_c('btn',{attrs:{"custom-class":"button-link small","text":_vm.cardData.button_text},on:{"btn-click":_vm.openContactUs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }